export const CHOOSE_ONE_TEXT = "Επιλέξτε ένα από τα παρακάτω";
export const FIELD_CANT_BE_EDITED_TEXT = "Το πεδίο δεν μπορεί να τροποποιηθεί";
export const SELECT_HERE_TEXT = "Επιλέξτε εδώ";
export const WRONG_TEXT = "Λάθος";
export const VALUE_OF_OPTION_CHOOSE_ONE = -1;
